/*
 * Build-time environment seam.
 *
 * Vite exposes build-time config on `import.meta.env` (only `VITE_*`-prefixed
 * vars), replacing each literal `import.meta.env.VITE_X` member access with its
 * value at build time. We funnel every env read through this single module so:
 *
 *   1. There is ONE authoritative `import.meta.env` reference in the codebase
 *      (DRY) — call sites read `env.VITE_X` instead of repeating the
 *      `import.meta.env` token.
 *   2. Tests can mock the whole seam with `jest.mock("utils/env", () => ...)`.
 *      This matters during the Jest era (pre-PR-3): CRA's babel-jest transpiles
 *      to CommonJS, where the `import.meta` token is a hard parse error
 *      ("Cannot use 'import.meta' outside a module"). A factory `jest.mock` of
 *      this module means Jest never parses the real file, so the token never
 *      reaches the CJS parser. Once the suite moves to Vitest (PR 3), Vitest
 *      parses `import.meta` natively and the mock can read real values.
 *
 * Under Vite, `import.meta.env` is a real runtime object, so reading
 * `env.VITE_X` resolves the statically-injected value. Under the legacy CRA
 * build, `import.meta.env` is absent — but CRA is no longer the env source of
 * truth after this rename (see docs/plans/2026-06-19-cra-to-vite-migration.md
 * PR 2): the deployed builder is Vite. This module is intentionally the only
 * place that would read `undefined` under CRA, keeping the breakage contained
 * and obvious rather than scattered.
 */

export const env = import.meta.env;
